import { render, staticRenderFns } from "./transportSource.vue?vue&type=template&id=cab55422&"
import script from "./transportSource.vue?vue&type=script&lang=js&"
export * from "./transportSource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cab55422')) {
      api.createRecord('cab55422', component.options)
    } else {
      api.reload('cab55422', component.options)
    }
    module.hot.accept("./transportSource.vue?vue&type=template&id=cab55422&", function () {
      api.rerender('cab55422', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/transportSource.vue"
export default component.exports